// StockWidget.jsx
import React from 'react';
import {
  IconBox,
  StockCard,
  TextBlock,
  Value,
} from './styles';
import { Button, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const StockWidget = ({
  bgColor,
  color,
  iconBg,
  icon: Icon,      // rename so we can render it
  label,
  quantity,
  qtyColor,
  ctaHref,
  ctaText = 'View in Inventory',
}) => (
  <StockCard sx={{borderLeft:`1px solid ${[color]}`}}>
    <div style={{display:'flex', flexDirection:'row', justifyContent:'center', width:'100%'}}>
<Typography variant="subtitle2">{label}</Typography>
    
    </div>
    
    

    <TextBlock style={{flexDirection:'row', alignItems:'center', justifyContent:'center', width:'100%'}}>
      <IconBox sx={{ backgroundColor: bgColor, display:'flex', borderRadius:'50%', justifyContent:'center', alignItems:'center', marginRight:'5px' }}>
      {Icon && <Icon sx={{ fontSize: 24, color: color, background:iconBg }} />}
    </IconBox>
      <Value>{quantity}</Value>
      
    </TextBlock>
    <Button component={RouterLink} to={ctaHref} sx={{
  fontSize: 13,
  fontWeight: 600,
  textDecoration: 'none',
  textTransform:'capitalize',
  width:'35px',
  minWidth:0,
  padding:'0',
  '&:hover': { textDecoration: 'underline', backgroundColor: 'transparent',  // keep same color
      boxShadow: 'none', },}}>{ctaText}
      </Button>
  </StockCard>
);

export default StockWidget;
